import Counter from '../../../internal/platformMetrics/aggregators/Counter';
export const safeParams = [
    'request',
    'miss'
];
export const translationCount = new Counter('i18n_translation_format_message_total');

//# sourceMappingURL=translationCount.js.map